import axios from "./axios"

/**
 * login
 * @param {*} code 
 */
const login = code => {
    return axios.get(`/loginOAuthCallback?code=${code}`).then(res => res.data)
}

/**
 * logout
 */
const logout = () => {
    return axios.get(`/oauth/logout`).then(res => res.data)
}

/**
 * getUserProfile
 */
const getUserProfile = () => {
    return axios.get(`/oauth/profile`).then(res => res.data)
}

export default {
    login,
    logout,
    getUserProfile
}